import type { CHART_METRIC } from '@/entities/chart/model/constants';
import { ChartMetricMap } from '@/features/(charts)/chart-renderer/model/chart-maps';

import {
  CHART_METRIC_POLICY,
  type ChartMetricPolicy,
} from './constants';

export const getChartMetricPolicy = (): ChartMetricPolicy => CHART_METRIC_POLICY;

export const getChartMetricLabel = (
  metric: CHART_METRIC | undefined,
): string => {
  const policy = getChartMetricPolicy();
  const safeMetric =
    metric && policy.metrics.includes(metric) ? metric : policy.fallbackMetric;

  return policy.labelOverrides?.[safeMetric] ?? ChartMetricMap.get(safeMetric) ?? '';
};
